"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Components = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _constant = require("../../styles/constant");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _templateObject, _templateObject2, _templateObject3;
const LabelContent = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n"])));
const LabelTooltip = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-left: ", ";\n  height: ", ";\n"])), (0, _constant.get)('space.4'), props => "".concat(props.height, "px"));
const customOrientation = (0, _styledSystem.variant)({
  prop: 'orientation',
  variants: {
    horizontal: {
      marginRight: (0, _constant.get)('space.6')
    },
    vertical: {
      marginBottom: (0, _constant.get)('space.4')
    }
  }
});
const variants = {
  customOrientation
};
const Label = _styledComponents["default"].label(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  align-items: center;\n  ", ";\n  & span.required {\n    &:after {\n      content: ' *';\n      color: ", ";\n    }\n  }\n  & span.optional {\n    margin-left: ", ";\n  }\n"])), props => props.fit === 'small' ? (0, _constant.get)('space.14') : (0, _constant.get)('space.16'), props => props.fit === 'small' ? (0, _constant.get)('space.20') : (0, _constant.get)('space.24'), (0, _constant.get)('colors.functional.grey.900'), variants.customOrientation, (0, _constant.get)('colors.feedback.danger.normal'), (0, _constant.get)('space.4'));
const Components = exports.Components = {
  LabelContent,
  LabelTooltip,
  Label
};